/**
 * utils
 *
 * @file utils.js
 * @author zhanghao25@baidu.com
 */
import _ from 'lodash';
import moment from 'moment';
import {router} from 'san-router';

export const getQueryVal = (url, variable) => {
    let query = url.split('?');
    let vars = [];
    _.each(query, item => {
        if (item.indexOf('#') !== -1) {
            item = item.split('#')[0];
        }
        vars = vars.concat(item.split('&'));
    });
    let val = false;
    _.each(vars, item => {
        let pair = item.split('=');
        if (pair[0] === variable) {
            val = pair[1];
        }
    });
    return val;
};

export const isConsole = () => {
    return location.href.includes('console.html');
};

export const isReadyPage = () => {
    return location.href.includes('#/meeting/join');
};

export const genOwnReadyPageUrl = (data, isCopy) => {
    const r = getQueryVal(data.room_url, 'r');
    const name = _.get(data, 'room_owner.name');
    const str = isCopy ? `&name=${encodeURIComponent(name)}` : '';
    return `${location.protocol}//${location.host}/console.html#/meeting/join?r=${r}${str}`;
};

export const addActiveClass = Dom => {
    let klassName = Dom.className;
    klassName.includes('active')
    ? klassName = klassName.replace('active', '')
    : klassName += ' active';
    Dom.className = klassName;
};

export const queryDom = str => document.querySelectorAll(str);

export const formatTime = value => {
    if (moment(value).format('YYYY.MM.DD') === moment(new Date()).format('YYYY.MM.DD')) {
        return value ? '今天' + moment(value).format(' HH:mm') : '-';
    }
    return value ? moment(value).format('YYYY.MM.DD HH:mm') : '-';
};

export const formatTimeNoYear = value => {
    if (moment(value).format('YYYY.MM.DD') === moment(new Date()).format('YYYY.MM.DD')) {
        return value ? '今天' + moment(value).format(' HH:mm') : '-';
    }
    return value ? moment(value).format('MM.DD HH:mm') : '-';
};

export const genRoomUrl = row => {
    if (!row || !row.room_owner) {
        return;
    }
    // eslint-disable-next-line
    return `${row.room_owner.username} 邀请你参加百度智能云Web视频会议`
            + '\n\n'
            + `主题： ${row.room_name}`
            + '\n'
            + `时间： ${formatTime(row.room_stime * 1000)}`
            + '\n'
            + `地点： ${row.room_site}`
            + '\n'
            + '请点击下方链接入会：'
            + `\n\n${genOwnReadyPageUrl(row)}`;
};

export const getCurMinute = () => {
    return moment().startOf('minute');
};

export const getTimeStamp = time => {
    let timeStamp = moment(time).format('YYYY/MM/DD HH:mm');
    return Number((new Date(timeStamp).getTime() / 1000).toFixed(0));
};

// 生成会议结束时间
export const getEndTime = (stime, duration) => moment(stime).add(duration, 'm');

let arr = ['@baidu.com', '@163.com', '@qq.com', '@sina.com', '@gmail.com'];

export const searchRequester = keyword => {
    return new Promise(res => {
        let result = _.map(arr, item => {
            if (keyword.includes('@')) {
                if (keyword.split(/@/)[1]) {
                    let name = keyword.split('@')[0];
                    return {
                        accountId: keyword,
                        username: name,
                        name
                    };
                }
                let email = `${keyword}${item.replace('@', '')}`;
                let name = keyword.replace('@', '');
                return {
                    accountId: email,
                    username: name,
                    name
                };
            }
            return {
                accountId: `${keyword}${item}`,
                username: keyword,
                name: keyword
            };
        });
        result[0].accountId === result[1].accountId
        ? res([result[0]])
        : res(result);
    });
};

export const isString = typeName => typeof typeName === 'string';

export const serializeQuery = query => {
    if (!query) {
        return '';
    }

    let search = '';
    for (const key in query) {
        if (query.hasOwnProperty(key)) {
            const value = query[key];

            // 如果`value`是数组，其`toString`会自动转为逗号分隔的字符串
            search += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(value.toString());
        }
    }

    return search.slice(1);
};

export const redirect = (url, option) => {
    let newUrl = '';
    if (typeof url === 'object') {
        if (url.module) {
            newUrl += `/${url.module}/`;
        }
        newUrl += `#${url.path}`;
        if (url.params) {
            newUrl += `${url.paramSeperator || '?'}${serializeQuery(url.params)}`;
        }
    }
    else if (isString(url)) {
        newUrl = url;
    }
    if (/^#/.test(newUrl)) {
        router.locator.redirect(newUrl.replace(/^#/, ''), option);
    }
    else {
        window.location.href = newUrl;
    }
};


// 获取浏览器 版本号、名称
export function getCurrentBrowserProfile() {
    const ua = navigator.userAgent.toLowerCase(); // 获取用户端信息
    const info = {
        ie: /msie/.test(ua) && !/opera/.test(ua), // 匹配IE浏览器
        opera: /opera/.test(ua), // 匹配Opera浏览器
        safari: /version.*safari/.test(ua), // 匹配Safari浏览器
        chrome: /chrome/.test(ua), // 匹配Chrome浏览器
        firefox: /gecko/.test(ua) && !/webkit/.test(ua) // 匹配Firefox浏览器
    };
    let target = {};
    for (const item of Object.keys(info)) {
        if (info[item]) {
            const versionStartStr = item === 'safari' ? 'version' : item;
            const reg = new RegExp(`${versionStartStr}/[0-9]+`, 'g');
            const match = ua.match(reg) || [''];
            const version = (match[0]).replace(`${versionStartStr}/`, '') - 0;
            target = {...target, name: item, version};
        }
    }
    return target;
}

// 判断是否为移动端
function isMobile() {
    if (navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
    ) {
        return true;
    } else {
        return false;
    }
}

export const isBrowserSupport = () => {
    const {name, version} = getCurrentBrowserProfile();
    if (isMobile()) {
        return true;
    } else {
        if ((name === 'chrome' && version >= 72) || (name === 'firefox' && version >= 72)) {
            return true;
        }
        return false;
    }
};

export const isZH = LANGUAGE === 'zh';
